'use client'

import { useEffect } from 'react'

import { messagingViewEvent } from '@marketplace-web/messaging/tracking-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

type Props = Pick<Parameters<typeof messagingViewEvent>[0], 'screen'>

const TrackMessagingViewEvent = ({ screen }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const conversationId = conversation?.id
  const userSide = conversation?.transaction?.userSide ?? 'unknown'

  useEffect(() => {
    switch (screen) {
      case 'inbox':
        track(messagingViewEvent({ screen, userSide }))
        break
      default:
        if (!conversationId) break

        track(messagingViewEvent({ screen, userSide, conversationId }))
        break
    }
  }, [track, screen, conversationId, userSide])

  return null
}

export default TrackMessagingViewEvent
